export const SEARCH_DEFAULT_FILTER = Object.freeze({
  per_page: 20,
});
export const DEFAULT_SEARCH_RESULT_CHER_LIMIT = 1000
